import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

interface ProfessionnelParticipantsStepProps {
  onComplete: (data: {
    nombreParticipants: number;
    contraintesLogistiques?: string;
  }) => void;
}

export const ProfessionnelParticipantsStep = ({ onComplete }: ProfessionnelParticipantsStepProps) => {
  const [nombreParticipants, setNombreParticipants] = useState<number>(0);
  const [contraintesLogistiques, setContraintesLogistiques] = useState('');

  const handleSubmit = () => {
    const data: any = { nombreParticipants };
    if (contraintesLogistiques) data.contraintesLogistiques = contraintesLogistiques;
    onComplete(data);
  };

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="nombreParticipants">Nombre de participants *</Label>
        <Input
          id="nombreParticipants"
          type="number"
          value={nombreParticipants || ''}
          onChange={(e) => setNombreParticipants(parseInt(e.target.value) || 0)}
          placeholder="Combien de participants ?"
          min="1"
          required
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="contraintes">Contraintes logistiques ou techniques (optionnel)</Label>
        <Textarea
          id="contraintes"
          value={contraintesLogistiques}
          onChange={(e) => setContraintesLogistiques(e.target.value)}
          placeholder="Horaires, matériel audiovisuel, accessibilité..."
          rows={3}
        />
      </div>

      <Button
        onClick={handleSubmit}
        disabled={nombreParticipants <= 0}
        className="w-full"
      >
        Continuer
      </Button>
    </div>
  );
};